export const getEmployeePageKeys = (key: string) => `employeeModule.employeePage.${key}`